import { api } from "@/lib/api";
import { log } from "@/lib/logger";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";

/**
 * Secure file download button. Fetches the file as a blob via authenticated
 * axios (cookies sent automatically), then triggers a browser download.
 * Never puts auth tokens in URLs (protects against referrer leakage / logs).
 */
export default function FileDownloadButton({ fileId, filename, className, "data-testid": dataTestId }) {
  const [busy, setBusy] = useState(false);

  const handleDownload = async () => {
    setBusy(true);
    try {
      const response = await api.get(`/files/${fileId}/download`, { responseType: "blob" });
      const blobUrl = URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename || `file-${fileId}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      toast.error("فشل تحميل الملف");
      log.error("File download failed:", err);
    }
    setBusy(false);
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={className}
      disabled={busy}
      onClick={handleDownload}
      data-testid={dataTestId}
    >
      <Download className="w-4 h-4 text-brand-amber" />
    </Button>
  );
}
